"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CommandMessageType_1 = require("../CommandMessageType");
class AbstractCommand {
    name;
    parameters;
    messageType;
    constructor(name, parameters, type = undefined) {
        this.name = name;
        this.parameters = parameters;
        this.messageType = type || CommandMessageType_1.CommandMessageType.COMMAND;
    }
    getMessageType() {
        return this.messageType;
    }
    toString() {
        let command = `${this.name},`;
        if (typeof this.parameters === 'string')
            return command.substring(0, command.length - 1);
        Object.keys(this.parameters).forEach(parameterName => command += `${parameterName}:${this.parameters[parameterName]},`);
        return command.substring(0, command.length - 1);
    }
}
exports.default = AbstractCommand;
